appSocial.service('LeadersCompareService', [
    '$rootScope', 'SocialTypes',
    function ($rootScope, SocialTypes) {

        const COMPARE_LIMIT = 2;

        class LeadersCompareService {
            constructor() {
                this.$rootScope = $rootScope;

                this.traders = [];
                this.isComparing = false;
                this.limitReached = false;
            }

            /**
             * @param {Trader} trader
             */
            add(trader) {
                this.traders.push(trader);
                this.setLimitReached();
                $rootScope.$broadcast('leadersCompare.add', {trader});
            }

            /**
             * @param {Trader} trader
             */
            remove(trader) {
                _.remove(this.traders, {id: trader.id});
                this.setLimitReached();
                $rootScope.$broadcast('leadersCompare.remove', {trader});
            }

            /**
             * @param {Trader} trader
             * @return {boolean}
             */
            isTraderComparing(trader) {
                return !!_.find(this.traders, {id: trader.id});
            }

            enableSelection() {
                this.traders.length = 0;
                this.isComparing = true;
                $rootScope.$broadcast('leadersCompare.enableSelection')
            }

            disableSelection() {
                this.traders.length = 0;
                this.isComparing = false;
                $rootScope.$broadcast('leadersCompare.disableSelection')
            }

            setLimitReached() {
                this.limitReached = this.traders.length >= COMPARE_LIMIT;
            }

            getCompareLimit() {
                return COMPARE_LIMIT;
            }
        }


        return new LeadersCompareService()
    }]);
